import { A9Service, AbstractDataProviderV2 } from 'components/system';
import { RsGolfFunction } from 'common/clubs';
import { RsGolfFunctionInfo } from 'common/customers/services/types/RsGolfFunctionInfo';
import { GolfFunctionAdd } from 'common/customers/services/types/GolfFunctionAdd';
import { GolfFunctionUpdate } from 'common/customers/services/types/GolfFunctionUpdate';

@A9Service('customerGolfFunctionDataProvider')
export class CustomerGolfFunctionDataProvider extends AbstractDataProviderV2<
    RsGolfFunction,
    RsGolfFunctionInfo,
    GolfFunctionAdd,
    GolfFunctionUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/golf-functions');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
